import {StrictMode} from 'react';
import {createRoot} from 'react-dom/client';
import App from './App';
import './index.css';

// Après un déploiement, une page ouverte depuis longtemps peut réclamer un fichier qui n'existe plus (page blanche).
// On recharge une seule fois pour récupérer la nouvelle version.
window.addEventListener('vite:preloadError', (event) => {
  try {
    const cle = 'iamani-rechargement-chunk';
    const dernier = Number(sessionStorage.getItem(cle) || 0);
    if (Date.now() - dernier < 30000) return;
    sessionStorage.setItem(cle, String(Date.now()));
    event.preventDefault();
    window.location.reload();
  } catch { /* stockage indisponible : on laisse l'erreur suivre son cours */ }
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
